import { GRID_SIZE } from '../constants';
import { UndergroundInfrastructureType, UndergroundLayer } from '../types/underground';
import { UNDERGROUND_INFRASTRUCTURE } from './undergroundInfrastructure';

export type UndergroundDemoPlacement = {
  x: number;
  y: number;
  type: UndergroundInfrastructureType;
  level: number;
  isConnected: boolean;
};

const center = Math.floor(GRID_SIZE / 2);

/** Placeholder underground tiles until MultiLayerGrid is wired to the surface grid. */
export const UNDERGROUND_DEMO_PLACEMENTS: Record<
  UndergroundLayer.Infrastructure | UndergroundLayer.Connectivity,
  UndergroundDemoPlacement[]
> = {
  [UndergroundLayer.Infrastructure]: [
    { x: center - 1, y: center, type: UndergroundInfrastructureType.DataConduit, level: 1, isConnected: true },
    { x: center + 1, y: center, type: UndergroundInfrastructureType.NetworkSwitch, level: 1, isConnected: true },
    { x: center, y: center - 1, type: UndergroundInfrastructureType.DistributionPanel, level: 1, isConnected: true },
  ],
  [UndergroundLayer.Connectivity]: [
    { x: center, y: center, type: UndergroundInfrastructureType.FiberBackbone, level: 1, isConnected: true },
    { x: center - 1, y: center + 1, type: UndergroundInfrastructureType.ServerRack, level: 1, isConnected: true },
    { x: center + 1, y: center - 1, type: UndergroundInfrastructureType.NetworkRack, level: 1, isConnected: false },
  ],
};

export function getUndergroundDemoPlacements(
  layer: UndergroundLayer
): UndergroundDemoPlacement[] {
  if (layer === UndergroundLayer.Surface) return [];
  return UNDERGROUND_DEMO_PLACEMENTS[layer] ?? [];
}

export function getUndergroundConfig(type: UndergroundInfrastructureType) {
  return UNDERGROUND_INFRASTRUCTURE[type];
}